/**
 * 時間を「数値 + 単位」の配列に変換（スコアカード用）
 * @param time 時間
 * @returns 時間を「数値 + 単位」の配列に変換したもの
 */
interface ScorecardTimeOptions {
  hourUnit?: string;
  minuteUnit?: string;
}

export const convertTimeForScorecard = (time: number, options?: ScorecardTimeOptions) => {
  // 時間が0の場合は空の配列を返す
  if (time == 0) return [];

  // 時間を取得
  const hours: string = Math.floor(time / 60).toString();
  // 分を取得
  const minutes: string = (time % 60).toString();

  const result = [];

  const hourUnit = options?.hourUnit ?? '時間';
  const minuteUnit = options?.minuteUnit ?? '分';

  // 時間は0の場合は表示しない
  if (hours !== '0') {
    result.push({ type: 'number', value: hours }, { type: 'unit', value: hourUnit });
  }
  // 分は必ず表示
  result.push({ type: 'number', value: minutes }, { type: 'unit', value: minuteUnit });

  return result;
};
